/**
 * Duplicated from ezyVet repo
 */
export var ZIndex;
(function (ZIndex) {
    ZIndex[ZIndex["DRAWER"] = 1200] = "DRAWER";
    ZIndex[ZIndex["DROPDOWN"] = 1000] = "DROPDOWN";
    ZIndex[ZIndex["MODAL"] = 1300] = "MODAL";
    ZIndex[ZIndex["PORTAL"] = 999999] = "PORTAL";
    ZIndex[ZIndex["MENU_PORTAL"] = 99999] = "MENU_PORTAL";
    ZIndex[ZIndex["TOOLTIP"] = 100001] = "TOOLTIP";
    ZIndex[ZIndex["TOAST"] = 999999] = "TOAST";
    ZIndex[ZIndex["NOTIFICATION"] = 999999] = "NOTIFICATION";
    ZIndex[ZIndex["COVER_BLOCK"] = 9999999999] = "COVER_BLOCK";
})(ZIndex || (ZIndex = {}));
//# sourceMappingURL=ZIndex.js.map